import { render, staticRenderFns } from "./machinesManager.vue?vue&type=template&id=8387de86&lang=pug"
import script from "./machinesManager.vue?vue&type=script&lang=js"
export * from "./machinesManager.vue?vue&type=script&lang=js"
import style0 from "./machinesManager.vue?vue&type=style&index=0&id=8387de86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports